module.exports = __webpack_public_path__ + "static/img/far1.4dd50f24.png";